import axios from 'axios'
import { apiFacebook } from '../config/env'
let headers = {
    'content-type': 'multipart/form-data',
}
const axiosIntanceAccesFacebook = axios.create({
    baseURL: apiFacebook,
    headers: headers
})
axiosIntanceAccesFacebook.interceptors.request.use(
    (config) => {
        const token = localStorage.getItem('accessToken');
        if (token) {
            config.headers.Authorization = `Bearer ${token}`
        }
        return config
    },
    (error) => {
        return Promise.reject(error);
    }
);

axiosIntanceAccesFacebook.interceptors.response.use(
    (response) => {
        return response;
    },
    (error) => {
        return Promise.reject(error);
    }
);

export default axiosIntanceAccesFacebook